var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemperatureIconGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 52,
    viewBox: "0 0 28 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M15.333 30.427c2.978 1.03 5.111 3.807 5.111 7.073 0 4.142-3.432 7.5-7.666 7.5S5.11 41.642 5.11 37.5c0-3.266 2.134-6.044 5.111-7.073V12.5h5.111v17.927z",
    transform: "translate(-673 -988) translate(84 880) translate(583 71) translate(7 38)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BCBCBC",
    d: "M5.111 27.5V7.666C5.111 3.432 8.544 0 12.778 0s7.666 3.432 7.666 7.667v19.832c3.104 2.28 5.112 5.911 5.112 10.001 0 6.904-5.721 12.5-12.778 12.5S0 44.404 0 37.5c0-4.09 2.008-7.72 5.111-10z",
    transform: "translate(-673 -988) translate(84 880) translate(583 71) translate(7 38)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureIconGrey);
export default __webpack_public_path__ + "static/media/temperature_icon_grey.53c6494144ca92c43fae596a431f26c1.svg";
export { ForwardRef as ReactComponent };